import React from 'react';
import { OwnerManualProps } from '../../pages/owner-manual/hook/use-owner-manual-content';
import { OwnerManualResponse } from '../../services/owner-manual-service/owner-manual-service';
import { nameplateMakeModelYearUtil } from '../../../components/utils/nameplate-model-year-util/nameplate-make-model-year-util';

interface Props {
    errorMsg: string;
    ownerManualData: OwnerManualResponse | null;
    ownerManualContent: OwnerManualProps;
    toggleSwitch: boolean;
}

const ownerManualError = (props: Props) => {
    const { errorMsg, ownerManualContent, ownerManualData } = props;
    return (
        <>
            <h1>
                {ownerManualData?.metadata.modelYear &&
                ownerManualData?.metadata.displayModelName
                    ? nameplateMakeModelYearUtil(
                          ownerManualData.metadata.displayModelName,
                          ownerManualData.metadata.modelYear
                      )
                    : `${' '}`}
                {' ' + ownerManualContent.subtitle}
            </h1>

            {errorMsg &&
                (+(
                    (ownerManualData?.metadata.modelYear &&
                        parseInt(ownerManualData?.metadata.modelYear)) ||
                    0
                ) < ownerManualContent.oldestYear ? (
                    <div className="owner-manual-error-message">
                        {ownerManualContent.tooOldMsg}
                    </div>
                ) : (
                    <div className="owner-manual-error-message">{errorMsg}</div>
                ))}
        </>
    );
};

export default ownerManualError;
